import React from 'react';
import classNames from 'classnames';
import styles from './quote.module.scss';
import LineByLine from '../line-by-line/line-by-line.component';

import { QuoteInterface } from './quote.interface';

const Quote: React.FunctionComponent<QuoteInterface> = ({
  className,
  title,
  text,
  author,
  hasAnimation = true,
}) => {
  return (
    <figure
      className={classNames(
        styles.component,
        className,
        {
          [styles.hasAnimation]: hasAnimation,
        },
      )}
    >
      {title && (
        <h3
          className={styles.title}
          data-letter={title[0]}
        >
          {hasAnimation
            ? <LineByLine text={title} />
            : title
          }
        </h3>
      )}

      <blockquote
        className={classNames(styles.quote)}
      >
        {text.split('\n').map(
          (thisItem, thisItemIndex) => hasAnimation
            ? <LineByLine key={thisItemIndex} text={`«${thisItem.replace(/\.$/, '')}»`} />
            : <React.Fragment key={thisItemIndex}>{thisItem}<br /></React.Fragment>
        )}
      </blockquote>

      {author && (
        <figcaption
          className={classNames(styles.author)}
        >
          {hasAnimation
            ? <LineByLine text={author} />
            : author
          }
        </figcaption>
      )}
    </figure>
  );
};

export default Quote;
